import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    const firstTab = this.tabTargets[0];
    const defaultTab = firstTab?.dataset.tab || "subtasks";
    this.showTab(defaultTab);
  }

  switch(event) {
    const tab = event.currentTarget.dataset.tab;
    this.showTab(tab);
  }

  showTab(tabId) {
    // Update tab buttons
    this.tabTargets.forEach((tab) => {
      const isSelected = tab.dataset.tab === tabId;
      tab.classList.toggle("text-indigo-600", isSelected);
      tab.classList.toggle("dark:text-indigo-400", isSelected);
      tab.classList.toggle("border-indigo-600", isSelected);
      tab.classList.toggle("dark:border-indigo-400", isSelected);
      tab.classList.toggle("border-transparent", !isSelected);
      tab.classList.toggle("text-slate-500", !isSelected);
      tab.classList.toggle("hover:text-slate-700", !isSelected);
      tab.classList.toggle("hover:border-slate-300", !isSelected);
      tab.classList.toggle("dark:text-slate-400", !isSelected);
      tab.classList.toggle("dark:hover:text-slate-300", !isSelected);
      tab.classList.toggle("dark:hover:border-slate-600", !isSelected);
    });

    // Update tab icons
    this.tabTargets.forEach((tab) => {
      const icon = tab.querySelector("svg");
      if (icon) {
        const isSelected = tab.dataset.tab === tabId;
        icon.classList.toggle("text-indigo-500", isSelected);
        icon.classList.toggle("text-slate-400", !isSelected);
        icon.classList.toggle("group-hover:text-slate-500", !isSelected);
        icon.classList.toggle("dark:group-hover:text-slate-300", !isSelected);
      }
    });

    // Update panels
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.tab !== tabId);
    });
  }
}
